import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterOutlet],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponent implements OnInit {
  message: string = '';
  receivedMessage: string = '';
  empData: any;
  empDataError: any;
  pollingInterval = 1000;
  pollingSubscription: Subscription = null!;

  loading: boolean = true; // Add a loading flag

  areaTypeCounts: { [key: string]: number } = {};
  areaTypeColors: { [key: string]: string } = {};

  constructor(
    private router: Router,
    private http: HttpClient,
    private httpService: HttpService
  ) {}

  ngOnInit(): void {
    // this.loadAreaTypeColors();
    this.startPolling();
    console.log('start');
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  startPolling(): void {
    this.pollingSubscription = interval(this.pollingInterval).subscribe(() => {
      this.fetchAllCounts();
    });
  }

  stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  // loadAreaTypeColors() {
  //   this.http
  //     .get<{ areaTypeColors: { [key: string]: string } }>('assets/users.json')
  //     .subscribe(
  //       (data) => {
  //         this.areaTypeColors = data.areaTypeColors;
  //         console.log("==---->", this.areaTypeColors);
  //         this.loading = false; // Set loading to false once data is fetched
  //       },
  //       (error) => {
  //         this.loading = false; // Set loading to false in case of an error
  //         console.error('Error loading area type colors:', error);
  //       }
  //     );
  // }

  fetchAllCounts() {
    this.httpService.getAllAreas().subscribe(
      (countsForAllAreas) => {
        this.areaTypeCounts = countsForAllAreas.result.Count;
        this.areaTypeColors = countsForAllAreas.result.Colour; // Ensure this is correctly assigned
        this.loading = false; // Set loading to false once data is fetched
      },
      (error) => {
        this.loading = false; // Set loading to false in case of an error
        console.error('Error fetching counts for all areas:', error);
      }
    );
  }

  getAreaTypeKeys(): string[] {
    return Object.keys(this.areaTypeCounts);
  }

  getAreaTypeColor(areaType: string): string {
  return this.areaTypeColors ? this.areaTypeColors[areaType] || '' : '';
}

  navigateToPage(page: string): void {
    console.log('Navigating to page:', page);
    const formattedPage = page.toLowerCase().replace(/\s+/g, ''); // Replace spaces with an empty string
    const count = this.areaTypeCounts[page];
    const areaTypes = page;
    this.httpService.setAreaType(areaTypes);
    this.router.navigate(['/dashboard/' + page]);
  }
}